export default __webpack_public_path__ + "src/assets/4b77672dcc53d0f9f227.png";